import Hero from '../components/home/Hero';
import ProductSection from '../components/home/ProductSection';
import WhyWired from '../components/home/WhyWired';
import BrandSection from '../components/home/BrandSection';
import FinalCta from '../components/home/FinalCta';

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <ProductSection />
      <WhyWired />
      <BrandSection />
      <FinalCta />
    </main>
  );
}
